import React from 'react';
import {race} from "../../../models/race";
import DateService from "../../../service/DateService";

type RaceCardProp = {
  race: race,
}

export const RaceCard = ({race}: RaceCardProp) => {
  return (
    <div className="max-w600px pe-4 mb-4">
      <div className="col">
        <div className={`__admin_season_card card shadow-sm`}>
          <div className="card-body">
            <h5 className="card-title">
              {race.label}
            </h5>

            <div className="mt-3 d-flex justify-content-between">
              <div className="card-text w-100">
                <div className="d-flex">
                  <div className="col">
                    {race.rideDate && (
                      <>
                        <strong className="me-1">Date :</strong>
                        {DateService
                          .toLocaleString(race.rideDate, {day: '2-digit', month: '2-digit', year: '2-digit'})
                        }
                      </>
                    )}
                  </div>
                  <div className="col text-end">
                    {(race.paid || race.subsidized) && (
                      <>
                        {race.paid && (
                          <><i className="fa-solid fa-money-bill-wave"/> Payée par le club</>
                        )}
                        {race.subsidized && (
                          <><i className="fa-solid fa-hand-holding-dollar"/> Subventionnée par le club</>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
